import qaOnlyLocalStorageFlagFilterTestActions from 'automation-ui-action-features/actions/extension/utils/qaOnlyLocalStorageFlagFilterTestActions';
import { registerQuery, useQuery } from 'data-fetching-client';
import fromPairs from 'hs-lodash/fromPairs';
import get from 'hs-lodash/get';
import http from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
const actionDefinitionFieldName = 'actionDefinition';
export const getActionDefinition = data => get(data, actionDefinitionFieldName);
export const GET_ACTION_DEFINITION = registerQuery({
  fieldName: actionDefinitionFieldName,
  args: ['id'],
  fetcher: ({
    id
  }) => http.get(`automation/v4/actions/internal/definitions/${id}`)
});
export const queryExtensionDefinition = WrappedComponent => props => {
  const {
    actionTypeId
  } = props;
  const {
    data,
    error,
    loading,
    refetch
  } = useQuery(GET_ACTION_DEFINITION, {
    skip: !actionTypeId,
    variables: {
      id: actionTypeId
    }
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    extensionDefinition: getActionDefinition(data),
    extensionDefinitionError: !!error,
    extensionDefinitionLoading: loading,
    refetchExtensionDefinition: refetch
  }));
};
export const useExtensionDefinition = actionTypeId => {
  const {
    data,
    error,
    loading,
    refetch
  } = useQuery(GET_ACTION_DEFINITION, {
    skip: !actionTypeId,
    variables: {
      id: actionTypeId
    }
  });
  return {
    extensionDefinition: getActionDefinition(data),
    error,
    loading,
    refetch
  };
};
export function getExtensionDefinitionByGroupId(groupId) {
  return http.get(`automation/v4/actions/internal/definitions/group/${groupId}`);
}
const GET_ALL_EXTENSION_DEFINITIONS_FIELDNAME = 'allExtensionDefinitions';
export const GET_ALL_EXTENSION_DEFINITIONS_V4 = registerQuery({
  fieldName: GET_ALL_EXTENSION_DEFINITIONS_FIELDNAME,
  args: ['objectType', 'createdSourceApp', 'actionTypeIdsToInclude', 'enrolledType'],
  fetcher: ({
    objectType,
    createdSourceApp,
    actionTypeIdsToInclude,
    shouldIncludeVisibleToAll,
    enrolledType = 'CRM_OBJECT'
  }) => http.post('automation/v4/actions/internal/access/definitions/filter', {
    data: {
      objectType,
      createdSourceApp,
      alwaysIncludeActionTypes: actionTypeIdsToInclude || [],
      shouldIncludeVisibleToAll,
      enrolledType
    }
  }).then(qaOnlyLocalStorageFlagFilterTestActions).then(response => {
    return fromPairs(response.results.map(definition => [definition.actionTypeId, definition]));
  })
});
export const useAllExtensionDefinitions = ({
  objectType,
  createdSourceApp,
  actionTypeIdsToInclude,
  shouldIncludeVisibleToAll,
  enrolledType
}) => useQuery(GET_ALL_EXTENSION_DEFINITIONS_V4, {
  variables: {
    objectType: objectType,
    createdSourceApp: createdSourceApp,
    actionTypeIdsToInclude,
    shouldIncludeVisibleToAll,
    enrolledType
  },
  skip: !objectType || !createdSourceApp
});
export const queryAllExtensionDefinitions = WrappedComponent => props => {
  var _flow$enrolledType;
  const {
    flowObjectTypeId,
    flowSourceApp,
    flow
  } = props;
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    allExtensionDefinitionsQuery: useAllExtensionDefinitions({
      objectType: flowObjectTypeId,
      createdSourceApp: flowSourceApp,
      enrolledType: flow === null || flow === void 0 || (_flow$enrolledType = flow.enrolledType) === null || _flow$enrolledType === void 0 ? void 0 : _flow$enrolledType.type
    })
  }));
};
const dynamicFieldSetFieldName = 'automationUiActionFeatures_dynamicFieldSet';
const stableEmptyArray = [];
export const getDynamicFieldSet = data => get(data, dynamicFieldSetFieldName, stableEmptyArray);
export const GET_DYNAMIC_FIELD_SET = registerQuery({
  fieldName: dynamicFieldSetFieldName,
  args: ['actionTypeId', 'dynamicFieldSetName', 'fields'],
  fetcher: ({
    actionTypeId,
    dynamicFieldSetName,
    fields
  }) => http.post('automationextensions2/v2/input-actions/fetch-fields', {
    query: {
      clienttimeout: 32000
    },
    data: {
      actionTypeId,
      inputActionName: dynamicFieldSetName,
      fields
    }
  }).then(response => {
    if (response['@result'] === 'ERR') {
      throw new Error('External response error');
    }
    return response.fields;
  })
});